import { z } from 'zod'
import { TrueFalse } from '~/enums/true-false'
import { listRequestDataSchema } from './list-request-data'

/**
 * 產品主類目 - 查詢多筆 Request Schema
 */
export const getProductMainListRequestSchema = listRequestDataSchema.merge(
  z.object({
    /** 主類目名稱 - 模糊查詢 */
    q: z.string().optional(),
    /** 可視角色 */
    roleCode: z.string().optional(),
    /** 是否上架 */
    isEnable: z.array(z.nativeEnum(TrueFalse)).optional()
  })
)

/**
 * 產品主類目 - 查詢多筆 Request
 */
export interface GetProductMainListRequest
  extends z.infer<typeof getProductMainListRequestSchema> {}
